import { render } from "./CustomInput.vue?vue&type=template&id=e2f59f46"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"

import "./CustomInput.vue?vue&type=style&index=0&id=e2f59f46&lang=css"
script.render = render

export default script